<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baNurseUser:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名">
                <a-input v-model="queryParam.realName" allow-clear placeholder="请输入姓名" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="身份证号">
                <a-input v-model="queryParam.idcardNo" allow-clear placeholder="请输入身份证号" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="手机号">
                <a-input v-model="queryParam.phone" allow-clear placeholder="请输入手机号" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert" :rowKey="(record) => record.id" :rowSelection="options.rowSelection">
        <!--<template class="table-operator" slot="operator" v-if="hasPerm('baNurseUser:add')">
          <a-button type="primary" v-if="hasPerm('baNurseUser:add')" icon="plus" @click="$refs.addForm.add()">新增护士端-用户表</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('baNurseUser:delete')" @click="batchDelete">
            <a-icon type="delete" />批量删除
          </a-button>
          <x-down v-if="hasPerm('baNurseUser:export')" ref="batchExport" @batchExport="batchExport" />
        </template>-->

        <span slot="action" slot-scope="text, record">
          <!--<a v-if="hasPerm('baNurseUser:edit')" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('baNurseUser:edit') & hasPerm('baNurseUser:delete')" />
          <a-popconfirm v-if="hasPerm('baNurseUser:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm>-->

          <a style="margin-right: 10px;" @click="handleOnRecord(record)">{{ record.isRecord == 0 ? '备案' : record.isRecord == 1 ? '重新备案' : '备案' }}</a>
        </span>
      </s-table>

      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>

<script>
  import {STable, XDown} from '@/components'
  import moment from 'moment'
  import {baNurseUserPage, baNurseUserDelete, baNurseUserExport, updateNurseRecord} from '@/api/modular/interhospital/banurseuser/baNurseUserManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'

  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },

    data() {
      return {
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {title: '姓名', align: 'center', dataIndex: 'realName'},
          {
            title: '性别', align: 'center', dataIndex: 'gender',
            customRender: text => text == '1' ? '男' : '女'
          },
          {title: '手机号', align: 'center', dataIndex: 'phone'},
          {title: '证书编号', align: 'center', dataIndex: 'certNo'},
          {
            title: '是否备案', align: 'center', dataIndex: 'isRecord',
            customRender: text => text == '1' ? '已备案' : '未备案'
          }
        ],
        tstyle: {'padding-bottom': '0px', 'margin-bottom': '10px'},
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baNurseUserPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: {
            show: true, clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },

    created() {
      if (this.hasPerm('baNurseUser:edit') || this.hasPerm('baNurseUser:delete')) {
        this.columns.push({
          title: '操作', width: '150px', dataIndex: 'action',
          scopedSlots: {customRender: 'action'}
        })
      }
    },

    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate() {
        const queryParambirthdate = this.queryParam.birthdateDate
        if (queryParambirthdate != null) {
          this.queryParam.birthdate = moment(queryParambirthdate).format('YYYY-MM-DD')
          if (queryParambirthdate.length < 1) {
            delete this.queryParam.birthdate
          }
        }

        const queryParamemploymentTime = this.queryParam.employmentTimeDate
        if (queryParamemploymentTime != null) {
          this.queryParam.employmentTime = moment(queryParamemploymentTime).format('YYYY-MM-DD')
          if (queryParamemploymentTime.length < 1) {
            delete this.queryParam.employmentTime
          }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },

      /**
       * 单个删除
       */
      singleDelete(record) {
        const param = [{'id': record.id}]
        this.baNurseUserDelete(param)
      },

      /**
       * 批量删除
       */
      batchDelete() {
        const paramIds = this.selectedRowKeys.map((d) => {
          return {'id': d}
        })
        this.baNurseUserDelete(paramIds)
      },

      baNurseUserDelete(record) {
        baNurseUserDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },

      /**
       * 批量导出
       */
      batchExport() {
        const paramIds = this.selectedRowKeys.map((d) => {
          return {'id': d}
        })
        baNurseUserExport(paramIds).then((res) => {
          this.$refs.batchExport.downloadfile(res)
        })
      },

      handleOk() {
        this.$refs.table.refresh()
      },

      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

      // 备案
      handleOnRecord(record) {
        const params = {id: record.id};

        updateNurseRecord(params).then(res => {
          if (res.code == 200) {
            this.$message.success('备案成功');
            this.handleOk();

          } else {
            this.$message.error('请稍后重试');
          }
        })
      },
    }
  }
</script>

<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }

  button {
    margin-right: 8px;
  }
</style>
